"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mimeTypes = void 0;
exports.mimeFromFile = mimeFromFile;
function mimeFromFile(file) {
    var type = file.mime && exports.mimeTypes.find(function (type) { return type.mime === file.mime; });
    if (!type) {
        var splitParts = file.name.split(/(?=\.)/);
        var extension_1 = splitParts.length > 1 ? splitParts[splitParts.length - 1] : undefined;
        type = extension_1 && exports.mimeTypes.find(function (type) { return type.extension === extension_1; });
    }
    return type;
}
exports.mimeTypes = [
    { name: "3D Crossword Plugin", mime: "application/vnd.hzn-3d-crossword", extension: ".x3d" },
    { name: "3GP", mime: "video/3gpp", extension: ".3gp" },
    { name: "3GP2", mime: "video/3gpp2", extension: ".3g2" },
    { name: "3GPP MSEQ File", mime: "application/vnd.mseq", extension: ".mseq" },
    { name: "3M Post It Notes", mime: "application/vnd.3m.post-it-notes", extension: ".pwn" },
    {
        name: "3rd Generation Partnership Project - Pic Large",
        mime: "application/vnd.3gpp.pic-bw-large",
        extension: ".plb",
    },
    {
        name: "3rd Generation Partnership Project - Pic Small",
        mime: "application/vnd.3gpp.pic-bw-small",
        extension: ".psb",
    },
    {
        name: "3rd Generation Partnership Project - Pic Var",
        mime: "application/vnd.3gpp.pic-bw-var",
        extension: ".pvb",
    },
    {
        name: "3rd Generation Partnership Project - Transaction Capabilities Application Part",
        mime: "application/vnd.3gpp2.tcap",
        extension: ".tcap",
    },
    { name: "7-Zip", mime: "application/x-7z-compressed", extension: ".7z" },
    { name: "AbiWord", mime: "application/x-abiword", extension: ".abw" },
    { name: "Ace Archive", mime: "application/x-ace-compressed", extension: ".ace" },
    {
        name: "Active Content Compression",
        mime: "application/vnd.americandynamics.acc",
        extension: ".acc",
    },
    { name: "ACU Cobol", mime: "application/vnd.acucobol", extension: ".acu" },
    { name: "ACU Cobol", mime: "application/vnd.acucorp", extension: ".atc" },
    { name: "Adaptive differential pulse-code modulation", mime: "audio/adpcm", extension: ".adp" },
    {
        name: "Adobe (Macropedia) Authorware - Binary File",
        mime: "application/x-authorware-bin",
        extension: ".aab",
    },
    {
        name: "Adobe (Macropedia) Authorware - Map",
        mime: "application/x-authorware-map",
        extension: ".aam",
    },
    {
        name: "Adobe (Macropedia) Authorware - Segment File",
        mime: "application/x-authorware-seg",
        extension: ".aas",
    },
    {
        name: "Adobe AIR Application",
        mime: "application/vnd.adobe.air-application-installer-package+zip",
        extension: ".air",
    },
    { name: "Adobe Flash", mime: "application/x-shockwave-flash", extension: ".swf" },
    { name: "Adobe Flex Project", mime: "application/vnd.adobe.fxp", extension: ".fxp" },
    { name: "Adobe Portable Document Format", mime: "application/pdf", extension: ".pdf" },
    {
        name: "Adobe PostScript Printer Description File Format",
        mime: "application/vnd.cups-ppd",
        extension: ".ppd",
    },
    { name: "Adobe Shockwave Player", mime: "application/x-director", extension: ".dir" },
    { name: "Adobe XML Data Package", mime: "application/vnd.adobe.xdp+xml", extension: ".xdp" },
    { name: "Adobe XML Forms Data Format", mime: "application/vnd.adobe.xfdf", extension: ".xfdf" },
    { name: "Advanced Audio Coding (AAC)", mime: "audio/x-aac", extension: ".aac" },
    { name: "Ahead AIR Application", mime: "application/vnd.ahead.space", extension: ".ahead" },
    { name: "AirZip FileSECURE", mime: "application/vnd.airzip.filesecure.azf", extension: ".azf" },
    { name: "AirZip FileSECURE", mime: "application/vnd.airzip.filesecure.azs", extension: ".azs" },
    { name: "Amazon Kindle eBook format", mime: "application/vnd.amazon.ebook", extension: ".azw" },
    { name: "AmigaDE", mime: "application/vnd.amiga.ami", extension: ".ami" },
    { name: "Andrew Toolkit", mime: "application/andrew-inset", extension: "N/A" },
    {
        name: "Android Package Archive",
        mime: "application/vnd.android.package-archive",
        extension: ".apk",
    },
    {
        name: "ANSER-WEB Terminal Client - Certificate Issue",
        mime: "application/vnd.anser-web-certificate-issue-initiation",
        extension: ".cii",
    },
    {
        name: "ANSER-WEB Terminal Client - Web Funds Transfer",
        mime: "application/vnd.anser-web-funds-transfer-initiation",
        extension: ".fti",
    },
    { name: "Antix Game Player", mime: "application/vnd.antix.game-component", extension: ".atx" },
    { name: "Apple Disk Image", mime: "application/x-apple-diskimage", extension: ".dmg" },
    {
        name: "Apple Installer Package",
        mime: "application/vnd.apple.installer+xml",
        extension: ".mpkg",
    },
    { name: "Applixware", mime: "application/applixware", extension: ".aw" },
    {
        name: "Archipelago Lesson Player",
        mime: "application/vnd.hhe.lesson-player",
        extension: ".les",
    },
    {
        name: "Arista Networks Software Image",
        mime: "application/vnd.aristanetworks.swi",
        extension: ".swi",
    },
    { name: "Assembler Source File", mime: "text/x-asm", extension: ".s" },
    { name: "Atom Publishing Protocol", mime: "application/atomcat+xml", extension: ".atomcat" },
    {
        name: "Atom Publishing Protocol Service Document",
        mime: "application/atomsvc+xml",
        extension: ".atomsvc",
    },
    { name: "Atom Syndication Format", mime: "application/atom+xml", extension: ".atom, .xml" },
    { name: "Attribute Certificate", mime: "application/pkix-attr-cert", extension: ".ac" },
    { name: "Audio Interchange File Format", mime: "audio/x-aiff", extension: ".aif" },
    { name: "Audio Video Interleave (AVI)", mime: "video/x-msvideo", extension: ".avi" },
    { name: "Audiograph", mime: "application/vnd.audiograph", extension: ".aep" },
    { name: "AutoCAD DXF", mime: "image/vnd.dxf", extension: ".dxf" },
    { name: "Autodesk Design Web Format (DWF)", mime: "model/vnd.dwf", extension: ".dwf" },
    { name: "BAS Partitur Format", mime: "text/plain-bas", extension: ".par" },
    { name: "Binary CPIO Archive", mime: "application/x-bcpio", extension: ".bcpio" },
    { name: "Binary Data", mime: "application/octet-stream", extension: ".bin" },
    { name: "Bitmap Image File", mime: "image/bmp", extension: ".bmp" },
    { name: "BitTorrent", mime: "application/x-bittorrent", extension: ".torrent" },
    { name: "Blackberry COD File", mime: "application/vnd.rim.cod", extension: ".cod" },
    {
        name: "Blueice Research Multipass",
        mime: "application/vnd.blueice.multipass",
        extension: ".mpm",
    },
    { name: "BMI Drawing Data Interchange", mime: "application/vnd.bmi", extension: ".bmi" },
    { name: "Bourne Shell Script", mime: "application/x-sh", extension: ".sh" },
    { name: "BTIF", mime: "image/prs.btif", extension: ".btif" },
    { name: "BusinessObjects", mime: "application/vnd.businessobjects", extension: ".rep" },
    { name: "Bzip Archive", mime: "application/x-bzip", extension: ".bz" },
    { name: "Bzip2 Archive", mime: "application/x-bzip2", extension: ".bz2" },
    { name: "C Shell Script", mime: "application/x-csh", extension: ".csh" },
    { name: "C Source File", mime: "text/x-c", extension: ".c" },
    { name: "CambridgeSoft Chem Draw", mime: "application/vnd.chemdraw+xml", extension: ".cdxml" },
    { name: "Cascading Style Sheets (CSS)", mime: "text/css", extension: ".css" },
    { name: "ChemDraw eXchange file", mime: "chemical/x-cdx", extension: ".cdx" },
    { name: "Chemical Markup Language", mime: "chemical/x-cml", extension: ".cml" },
    { name: "Chemical Style Markup Language", mime: "chemical/x-csml", extension: ".csml" },
    { name: "CIM Database", mime: "application/vnd.contact.cmsg", extension: ".cdbcmsg" },
    { name: "Claymore Data Files", mime: "application/vnd.claymore", extension: ".cla" },
    { name: "Clonk Game", mime: "application/vnd.clonk.c4group", extension: ".c4g" },
    { name: "Close Captioning - Subtitle", mime: "image/vnd.dvb.subtitle", extension: ".sub" },
    {
        name: "Cloud Data Management Interface (CDMI) - Capability",
        mime: "application/cdmi-capability",
        extension: ".cdmia",
    },
    {
        name: "Cloud Data Management Interface (CDMI) - Contaimer",
        mime: "application/cdmi-container",
        extension: ".cdmic",
    },
    {
        name: "Cloud Data Management Interface (CDMI) - Domain",
        mime: "application/cdmi-domain",
        extension: ".cdmid",
    },
    {
        name: "Cloud Data Management Interface (CDMI) - Object",
        mime: "application/cdmi-object",
        extension: ".cdmio",
    },
    {
        name: "Cloud Data Management Interface (CDMI) - Queue",
        mime: "application/cdmi-queue",
        extension: ".cdmiq",
    },
    {
        name: "ClueTrust CartoMobile - Config",
        mime: "application/vnd.cluetrust.cartomobile-config",
        extension: ".c11amc",
    },
    {
        name: "ClueTrust CartoMobile - Config Package",
        mime: "application/vnd.cluetrust.cartomobile-config-pkg",
        extension: ".c11amz",
    },
    { name: "CMU Image", mime: "image/x-cmu-raster", extension: ".ras" },
    { name: "COLLADA", mime: "model/vnd.collada+xml", extension: ".dae" },
    { name: "Comma-Seperated Values", mime: "text/csv", extension: ".csv" },
    { name: "Compact Pro", mime: "application/mac-compactpro", extension: ".cpt" },
    {
        name: "Compiled Wireless Markup Language (WMLC)",
        mime: "application/vnd.wap.wmlc",
        extension: ".wmlc",
    },
    { name: "Computer Graphics Metafile", mime: "image/cgm", extension: ".cgm" },
    { name: "CoolTalk", mime: "x-conference/x-cooltalk", extension: ".ice" },
    { name: "Corel Metafile Exchange (CMX)", mime: "image/x-cmx", extension: ".cmx" },
    { name: "CorelXARA", mime: "application/vnd.xara", extension: ".xar" },
    { name: "CosmoCaller", mime: "application/vnd.cosmocaller", extension: ".cmc" },
    { name: "CPIO Archive", mime: "application/x-cpio", extension: ".cpio" },
    { name: "CrickSoftware - Clicker", mime: "application/vnd.crick.clicker", extension: ".clkx" },
    {
        name: "CrickSoftware - Clicker - Keyboard",
        mime: "application/vnd.crick.clicker.keyboard",
        extension: ".clkk",
    },
    {
        name: "CrickSoftware - Clicker - Palette",
        mime: "application/vnd.crick.clicker.palette",
        extension: ".clkp",
    },
    {
        name: "CrickSoftware - Clicker - Template",
        mime: "application/vnd.crick.clicker.template",
        extension: ".clkt",
    },
    {
        name: "CrickSoftware - Clicker - Wordbank",
        mime: "application/vnd.crick.clicker.wordbank",
        extension: ".clkw",
    },
    {
        name: "Critical Tools - PERT Chart EXPERT",
        mime: "application/vnd.criticaltools.wbs+xml",
        extension: ".wbs",
    },
    { name: "CryptoNote", mime: "application/vnd.rig.cryptonote", extension: ".cryptonote" },
    { name: "Crystallographic Interchange Format", mime: "chemical/x-cif", extension: ".cif" },
    { name: "CrystalMaker Data Format", mime: "chemical/x-cmdf", extension: ".cmdf" },
    { name: "CU-SeeMe", mime: "application/cu-seeme", extension: ".cu" },
    { name: "CU-Writer", mime: "application/prs.cww", extension: ".cww" },
    { name: "Curl - Applet", mime: "text/vnd.curl", extension: ".curl" },
    { name: "Curl - Detached Applet", mime: "text/vnd.curl.dcurl", extension: ".dcurl" },
    { name: "Curl - Manifest File", mime: "text/vnd.curl.mcurl", extension: ".mcurl" },
    { name: "Curl - Source Code", mime: "text/vnd.curl.scurl", extension: ".scurl" },
    { name: "CURL Applet", mime: "application/vnd.curl.car", extension: ".car" },
    { name: "CURL Applet", mime: "application/vnd.curl.pcurl", extension: ".pcurl" },
    { name: "CustomMenu", mime: "application/vnd.yellowriver-custom-menu", extension: ".cmp" },
    {
        name: "Data Structure for the Security Suitability of Cryptographic Algorithms",
        mime: "application/dssc+der",
        extension: ".dssc",
    },
    {
        name: "Data Structure for the Security Suitability of Cryptographic Algorithms",
        mime: "application/dssc+xml",
        extension: ".xdssc",
    },
    { name: "Debian Package", mime: "application/x-debian-package", extension: ".deb" },
    { name: "DECE Audio", mime: "audio/vnd.dece.audio", extension: ".uva" },
    { name: "DECE Graphic", mime: "image/vnd.dece.graphic", extension: ".uvi" },
    { name: "DECE High Definition Video", mime: "video/vnd.dece.hd", extension: ".uvh" },
    { name: "DECE Mobile Video", mime: "video/vnd.dece.mobile", extension: ".uvm" },
    { name: "DECE MP4", mime: "video/vnd.uvvu.mp4", extension: ".uvu" },
    { name: "DECE PD Video", mime: "video/vnd.dece.pd", extension: ".uvp" },
    { name: "DECE SD Video", mime: "video/vnd.dece.sd", extension: ".uvs" },
    { name: "DECE Video", mime: "video/vnd.dece.video", extension: ".uvv" },
    { name: "Device Independent File Format (DVI)", mime: "application/x-dvi", extension: ".dvi" },
    {
        name: "Digital Siesmograph Networks - SEED Datafiles",
        mime: "application/vnd.fdsn.seed",
        extension: ".seed",
    },
    { name: "Digital Talking Book", mime: "application/x-dtbook+xml", extension: ".dtb" },
    {
        name: "Digital Talking Book - Resource File",
        mime: "application/x-dtbresource+xml",
        extension: ".res",
    },
    { name: "Digital Video Broadcasting", mime: "application/vnd.dvb.ait", extension: ".ait" },
    { name: "Digital Video Broadcasting", mime: "application/vnd.dvb.service", extension: ".svc" },
    { name: "Digital Winds Music", mime: "audio/vnd.digital-winds", extension: ".eol" },
    { name: "DjVu", mime: "image/vnd.djvu", extension: ".djvu" },
    { name: "Document Type Definition", mime: "application/xml-dtd", extension: ".dtd" },
    { name: "Dolby Meridian Lossless Packing", mime: "application/vnd.dolby.mlp", extension: ".mlp" },
    { name: "Doom Video Game", mime: "application/x-doom", extension: ".wad" },
    { name: "DPGraph", mime: "application/vnd.dpgraph", extension: ".dpg" },
    { name: "DRA Audio", mime: "audio/vnd.dra", extension: ".dra" },
    { name: "DreamFactory", mime: "application/vnd.dreamfactory", extension: ".dfac" },
    { name: "DTS Audio", mime: "audio/vnd.dts", extension: ".dts" },
    { name: "DTS High Definition Audio", mime: "audio/vnd.dts.hd", extension: ".dtshd" },
    { name: "DWG Drawing", mime: "image/vnd.dwg", extension: ".dwg" },
    { name: "DynaGeo", mime: "application/vnd.dynageo", extension: ".geo" },
    { name: "ECMAScript", mime: "application/ecmascript", extension: ".es" },
    { name: "EcoWin Chart", mime: "application/vnd.ecowin.chart", extension: ".mag" },
    { name: "EDMICS 2000", mime: "image/vnd.fujixerox.edmics-mmr", extension: ".mmr" },
    { name: "EDMICS 2000", mime: "image/vnd.fujixerox.edmics-rlc", extension: ".rlc" },
    { name: "Efficient XML Interchange", mime: "application/exi", extension: ".exi" },
    { name: "EFI Proteus", mime: "application/vnd.proteus.magazine", extension: ".mgz" },
    { name: "Electronic Publication", mime: "application/epub+zip", extension: ".epub" },
    { name: "Email Message", mime: "message/rfc822", extension: ".eml" },
    { name: "Enliven Viewer", mime: "application/vnd.enliven", extension: ".nml" },
    { name: "Express by Infoseek", mime: "application/vnd.is-xpr", extension: ".xpr" },
    { name: "eXtended Image File Format (XIFF)", mime: "image/vnd.xiff", extension: ".xif" },
    {
        name: "Extensible Forms Description Language",
        mime: "application/vnd.xfdl",
        extension: ".xfdl",
    },
    { name: "Extensible MultiModal Annotation", mime: "application/emma+xml", extension: ".emma" },
    { name: "EZPix Secure Photo Album", mime: "application/vnd.ezpix-album", extension: ".ez2" },
    { name: "EZPix Secure Photo Album", mime: "application/vnd.ezpix-package", extension: ".ez3" },
    { name: "FAST Search & Transfer ASA", mime: "image/vnd.fst", extension: ".fst" },
    { name: "FAST Search & Transfer ASA", mime: "video/vnd.fvt", extension: ".fvt" },
    { name: "FastBid Sheet", mime: "image/vnd.fastbidsheet", extension: ".fbs" },
    {
        name: "FCS Express Layout Link",
        mime: "application/vnd.denovo.fcselayout-link",
        extension: ".fe_launch",
    },
    { name: "Flash Video", mime: "video/x-f4v", extension: ".f4v" },
    { name: "Flash Video", mime: "video/x-flv", extension: ".flv" },
    { name: "FlashPix", mime: "image/vnd.fpx", extension: ".fpx" },
    { name: "FlashPix", mime: "image/vnd.net-fpx", extension: ".npx" },
    { name: "FLEXSTOR", mime: "text/vnd.fmi.flexstor", extension: ".flx" },
    { name: "FLI/FLC Animation Format", mime: "video/x-fli", extension: ".fli" },
    { name: "FluxTime Clip", mime: "application/vnd.fluxtime.clip", extension: ".ftc" },
    { name: "Forms Data Format", mime: "application/vnd.fdf", extension: ".fdf" },
    { name: "Fortran Source File", mime: "text/x-fortran", extension: ".f" },
    { name: "FrameMaker Interchange Format", mime: "application/vnd.mif", extension: ".mif" },
    { name: "FrameMaker Normal Format", mime: "application/vnd.framemaker", extension: ".fm" },
    { name: "FreeHand MX", mime: "image/x-freehand", extension: ".fh" },
    {
        name: "Friendly Software Corporation",
        mime: "application/vnd.fsc.weblaunch",
        extension: ".fsc",
    },
    { name: "Frogans Player", mime: "application/vnd.frogans.fnc", extension: ".fnc" },
    { name: "Frogans Player", mime: "application/vnd.frogans.ltf", extension: ".ltf" },
    { name: "Fujitsu - Xerox 2D CAD Data", mime: "application/vnd.fujixerox.ddd", extension: ".ddd" },
    {
        name: "Fujitsu - Xerox DocuWorks",
        mime: "application/vnd.fujixerox.docuworks",
        extension: ".xdw",
    },
    {
        name: "Fujitsu - Xerox DocuWorks Binder",
        mime: "application/vnd.fujixerox.docuworks.binder",
        extension: ".xbd",
    },
    { name: "Fujitsu Oasys", mime: "application/vnd.fujitsu.oasys", extension: ".oas" },
    { name: "Fujitsu Oasys", mime: "application/vnd.fujitsu.oasys2", extension: ".oa2" },
    { name: "Fujitsu Oasys", mime: "application/vnd.fujitsu.oasys3", extension: ".oa3" },
    { name: "Fujitsu Oasys", mime: "application/vnd.fujitsu.oasysgp", extension: ".fg5" },
    { name: "Fujitsu Oasys", mime: "application/vnd.fujitsu.oasysprs", extension: ".bh2" },
    { name: "FutureSplash Animator", mime: "application/x-futuresplash", extension: ".spl" },
    { name: "FuzzySheet", mime: "application/vnd.fuzzysheet", extension: ".fzs" },
    { name: "G3 Fax Image", mime: "image/g3fax", extension: ".g3" },
    { name: "GameMaker ActiveX", mime: "application/vnd.gmx", extension: ".gmx" },
    { name: "Gen-Trix Studio", mime: "model/vnd.gtw", extension: ".gtw" },
    {
        name: "Genomatix Tuxedo Framework",
        mime: "application/vnd.genomatix.tuxedo",
        extension: ".txd",
    },
    { name: "GeoGebra", mime: "application/vnd.geogebra.file", extension: ".ggb" },
    { name: "GeoGebra", mime: "application/vnd.geogebra.tool", extension: ".ggt" },
    { name: "Geometric Description Language (GDL)", mime: "model/vnd.gdl", extension: ".gdl" },
    { name: "GeoMetry Explorer", mime: "application/vnd.geometry-explorer", extension: ".gex" },
    { name: "GEONExT and JSXGraph", mime: "application/vnd.geonext", extension: ".gxt" },
    { name: "GeoplanW", mime: "application/vnd.geoplan", extension: ".g2w" },
    { name: "GeospacW", mime: "application/vnd.geospace", extension: ".g3w" },
    { name: "Ghostscript Font", mime: "application/x-font-ghostscript", extension: ".gsf" },
    { name: "Glyph Bitmap Distribution Format", mime: "application/x-font-bdf", extension: ".bdf" },
    { name: "GNU Tar Files", mime: "application/x-gtar", extension: ".gtar" },
    { name: "GNU Texinfo Document", mime: "application/x-texinfo", extension: ".texinfo" },
    { name: "Gnumeric", mime: "application/x-gnumeric", extension: ".gnumeric" },
    { name: "Google Earth - KML", mime: "application/vnd.google-earth.kml+xml", extension: ".kml" },
    {
        name: "Google Earth - Zipped KML",
        mime: "application/vnd.google-earth.kmz",
        extension: ".kmz",
    },
    { name: "GrafEq", mime: "application/vnd.grafeq", extension: ".gqf" },
    { name: "Graphics Interchange Format", mime: "image/gif", extension: ".gif" },
    { name: "Graphviz", mime: "text/vnd.graphviz", extension: ".gv" },
    { name: "Groove - Account", mime: "application/vnd.groove-account", extension: ".gac" },
    { name: "Groove - Help", mime: "application/vnd.groove-help", extension: ".ghf" },
    {
        name: "Groove - Identity Message",
        mime: "application/vnd.groove-identity-message",
        extension: ".gim",
    },
    { name: "Groove - Injector", mime: "application/vnd.groove-injector", extension: ".grv" },
    { name: "Groove - Tool Message", mime: "application/vnd.groove-tool-message", extension: ".gtm" },
    {
        name: "Groove - Tool Template",
        mime: "application/vnd.groove-tool-template",
        extension: ".tpl",
    },
    { name: "Groove - Vcard", mime: "application/vnd.groove-vcard", extension: ".vcg" },
    { name: "H.261", mime: "video/h261", extension: ".h261" },
    { name: "H.263", mime: "video/h263", extension: ".h263" },
    { name: "H.264", mime: "video/h264", extension: ".h264" },
    { name: "Hewlett Packard Instant Delivery", mime: "application/vnd.hp-hpid", extension: ".hpid" },
    { name: "Hewlett-Packard's WebPrintSmart", mime: "application/vnd.hp-hps", extension: ".hps" },
    { name: "Hierarchical Data Format", mime: "application/x-hdf", extension: ".hdf" },
    { name: "Hit'n'Mix", mime: "audio/vnd.rip", extension: ".rip" },
    {
        name: "Homebanking Computer Interface (HBCI)",
        mime: "application/vnd.hbci",
        extension: ".hbci",
    },
    {
        name: "HP Indigo Digital Press - Job Layout Languate",
        mime: "application/vnd.hp-jlyt",
        extension: ".jlt",
    },
    { name: "HP Printer Command Language", mime: "application/vnd.hp-pcl", extension: ".pcl" },
    { name: "HP-GL/2 and HP RTL", mime: "application/vnd.hp-hpgl", extension: ".hpgl" },
    { name: "HV Script", mime: "application/vnd.yamaha.hv-script", extension: ".hvs" },
    { name: "HV Voice Dictionary", mime: "application/vnd.yamaha.hv-dic", extension: ".hvd" },
    { name: "HV Voice Parameter", mime: "application/vnd.yamaha.hv-voice", extension: ".hvp" },
    {
        name: "Hydrostatix Master Suite",
        mime: "application/vnd.hydrostatix.sof-data",
        extension: ".sfd-hdstx",
    },
    { name: "Hyperstudio", mime: "application/hyperstudio", extension: ".stk" },
    { name: "Hypertext Application Language", mime: "application/vnd.hal+xml", extension: ".hal" },
    { name: "HyperText Markup Language (HTML)", mime: "text/html", extension: ".html" },
    {
        name: "IBM DB2 Rights Manager",
        mime: "application/vnd.ibm.rights-management",
        extension: ".irm",
    },
    {
        name: "IBM Electronic Media Management System - Secure Container",
        mime: "application/vnd.ibm.secure-container",
        extension: ".sc",
    },
    { name: "iCalendar", mime: "text/calendar", extension: ".ics" },
    { name: "ICC profile", mime: "application/vnd.iccprofile", extension: ".icc" },
    { name: "Icon Image", mime: "image/x-icon", extension: ".ico" },
    { name: "igLoader", mime: "application/vnd.igloader", extension: ".igl" },
    { name: "Image Exchange Format", mime: "image/ief", extension: ".ief" },
    { name: "ImmerVision PURE Players", mime: "application/vnd.immervision-ivp", extension: ".ivp" },
    { name: "ImmerVision PURE Players", mime: "application/vnd.immervision-ivu", extension: ".ivu" },
    { name: "IMS Networks", mime: "application/reginfo+xml", extension: ".rif" },
    { name: "In3D - 3DML", mime: "text/vnd.in3d.3dml", extension: ".3dml" },
    { name: "In3D - 3DML", mime: "text/vnd.in3d.spot", extension: ".spot" },
    { name: "Initial Graphics Exchange Specification (IGES)", mime: "model/iges", extension: ".igs" },
    { name: "Interactive Geometry Software", mime: "application/vnd.intergeo", extension: ".i2g" },
    {
        name: "Interactive Geometry Software Cinderella",
        mime: "application/vnd.cinderella",
        extension: ".cdy",
    },
    { name: "Intercon FormNet", mime: "application/vnd.intercon.formnet", extension: ".xpw" },
    {
        name: "International Society for Advancement of Cytometry",
        mime: "application/vnd.isac.fcs",
        extension: ".fcs",
    },
    {
        name: "Internet Protocol Flow Information Export",
        mime: "application/ipfix",
        extension: ".ipfix",
    },
    {
        name: "Internet Public Key Infrastructure - Certificate",
        mime: "application/pkix-cert",
        extension: ".cer",
    },
    {
        name: "Internet Public Key Infrastructure - Certificate Management Protocole",
        mime: "application/pkixcmp",
        extension: ".pki",
    },
    {
        name: "Internet Public Key Infrastructure - Certificate Revocation Lists",
        mime: "application/pkix-crl",
        extension: ".crl",
    },
    {
        name: "Internet Public Key Infrastructure - Certification Path",
        mime: "application/pkix-pkipath",
        extension: ".pkipath",
    },
    { name: "IOCOM Visimeet", mime: "application/vnd.insors.igm", extension: ".igm" },
    {
        name: "IP Unplugged Roaming Client",
        mime: "application/vnd.ipunplugged.rcprofile",
        extension: ".rcprofile",
    },
    {
        name: "iRepository / Lucidoc Editor",
        mime: "application/vnd.irepository.package+xml",
        extension: ".irp",
    },
    { name: "J2ME App Descriptor", mime: "text/vnd.sun.j2me.app-descriptor", extension: ".jad" },
    { name: "Java Archive", mime: "application/java-archive", extension: ".jar" },
    { name: "Java Bytecode File", mime: "application/java-vm", extension: ".class" },
    {
        name: "Java Network Launching Protocol",
        mime: "application/x-java-jnlp-file",
        extension: ".jnlp",
    },
    { name: "Java Serialized Object", mime: "application/java-serialized-object", extension: ".ser" },
    { name: "Java Source File", mime: "text/x-java-source,java", extension: ".java" },
    { name: "JavaScript", mime: "application/javascript", extension: ".js" },
    { name: "JavaScript Object Notation (JSON)", mime: "application/json", extension: ".json" },
    { name: "Joda Archive", mime: "application/vnd.joost.joda-archive", extension: ".joda" },
    { name: "JPEG 2000 Compound Image File Format", mime: "video/jpm", extension: ".jpm" },
    { name: "JPEG Image", mime: "image/jpeg", extension: ".jpeg, .jpg" },
    { name: "JPEG Image (Citrix client)", mime: "image/x-citrix-jpeg", extension: ".jpeg, .jpg" },
    { name: "JPEG Image (Progressive)", mime: "image/pjpeg", extension: ".pjpeg" },
    { name: "JPGVideo", mime: "video/jpeg", extension: ".jpgv" },
    { name: "Kahootz", mime: "application/vnd.kahootz", extension: ".ktz" },
    {
        name: "Karaoke on Chipnuts Chipsets",
        mime: "application/vnd.chipnuts.karaoke-mmd",
        extension: ".mmd",
    },
    {
        name: "KDE KOffice Office Suite - Karbon",
        mime: "application/vnd.kde.karbon",
        extension: ".karbon",
    },
    {
        name: "KDE KOffice Office Suite - KChart",
        mime: "application/vnd.kde.kchart",
        extension: ".chrt",
    },
    {
        name: "KDE KOffice Office Suite - Kformula",
        mime: "application/vnd.kde.kformula",
        extension: ".kfo",
    },
    {
        name: "KDE KOffice Office Suite - Kivio",
        mime: "application/vnd.kde.kivio",
        extension: ".flw",
    },
    {
        name: "KDE KOffice Office Suite - Kontour",
        mime: "application/vnd.kde.kontour",
        extension: ".kon",
    },
    {
        name: "KDE KOffice Office Suite - Kpresenter",
        mime: "application/vnd.kde.kpresenter",
        extension: ".kpr",
    },
    {
        name: "KDE KOffice Office Suite - Kspread",
        mime: "application/vnd.kde.kspread",
        extension: ".ksp",
    },
    {
        name: "KDE KOffice Office Suite - Kword",
        mime: "application/vnd.kde.kword",
        extension: ".kwd",
    },
    { name: "Kenamea App", mime: "application/vnd.kenameaapp", extension: ".htke" },
    { name: "Kidspiration", mime: "application/vnd.kidspiration", extension: ".kia" },
    { name: "Kinar Applications", mime: "application/vnd.kinar", extension: ".kne" },
    { name: "Kodak Storyshare", mime: "application/vnd.kodak-descriptor", extension: ".sse" },
    { name: "Laser App Enterprise", mime: "application/vnd.las.las+xml", extension: ".lasxml" },
    { name: "LaTeX", mime: "application/x-latex", extension: ".latex" },
    {
        name: "Life Balance - Desktop Edition",
        mime: "application/vnd.llamagraphics.life-balance.desktop",
        extension: ".lbd",
    },
    {
        name: "Life Balance - Exchange Format",
        mime: "application/vnd.llamagraphics.life-balance.exchange+xml",
        extension: ".lbe",
    },
    { name: "Lightspeed Audio Lab", mime: "application/vnd.jam", extension: ".jam" },
    { name: "Lotus 1-2-3", mime: "application/vnd.lotus-1-2-3", extension: "0.123" },
    { name: "Lotus Approach", mime: "application/vnd.lotus-approach", extension: ".apr" },
    { name: "Lotus Freelance", mime: "application/vnd.lotus-freelance", extension: ".pre" },
    { name: "Lotus Notes", mime: "application/vnd.lotus-notes", extension: ".nsf" },
    { name: "Lotus Organizer", mime: "application/vnd.lotus-organizer", extension: ".org" },
    { name: "Lotus Screencam", mime: "application/vnd.lotus-screencam", extension: ".scm" },
    { name: "Lotus Wordpro", mime: "application/vnd.lotus-wordpro", extension: ".lwp" },
    { name: "Lucent Voice", mime: "audio/vnd.lucent.voice", extension: ".lvp" },
    { name: "M3U (Multimedia Playlist)", mime: "audio/x-mpegurl", extension: ".m3u" },
    { name: "M4v", mime: "video/x-m4v", extension: ".m4v" },
    { name: "Macintosh BinHex 4.0", mime: "application/mac-binhex40", extension: ".hqx" },
    { name: "MacPorts Port System", mime: "application/vnd.macports.portpkg", extension: ".portpkg" },
    { name: "MapGuide DBXML", mime: "application/vnd.osgeo.mapguide.package", extension: ".mgp" },
    { name: "MARC Formats", mime: "application/marc", extension: ".mrc" },
    { name: "MARC21 XML Schema", mime: "application/marcxml+xml", extension: ".mrcx" },
    { name: "Material Exchange Format", mime: "application/mxf", extension: ".mxf" },
    {
        name: "Mathematica Notebook Player",
        mime: "application/vnd.wolfram.player",
        extension: ".nbp",
    },
    { name: "Mathematica Notebooks", mime: "application/mathematica", extension: ".ma" },
    { name: "Mathematical Markup Language", mime: "application/mathml+xml", extension: ".mathml" },
    { name: "Mbox database files", mime: "application/mbox", extension: ".mbox" },
    { name: "MedCalc", mime: "application/vnd.medcalcdata", extension: ".mc1" },
    {
        name: "Media Server Control Markup Language",
        mime: "application/mediaservercontrol+xml",
        extension: ".mscml",
    },
    { name: "MediaRemote", mime: "application/vnd.mediastation.cdkey", extension: ".cdkey" },
    { name: "Medical Waveform Encoding Format", mime: "application/vnd.mfer", extension: ".mwf" },
    { name: "Melody Format for Mobile Platform", mime: "application/vnd.mfmp", extension: ".mfm" },
    { name: "Mesh Data Type", mime: "model/mesh", extension: ".msh" },
    {
        name: "Metadata Authority Description Schema",
        mime: "application/mads+xml",
        extension: ".mads",
    },
    {
        name: "Metadata Encoding and Transmission Standard",
        mime: "application/mets+xml",
        extension: ".mets",
    },
    { name: "Metadata Object Description Schema", mime: "application/mods+xml", extension: ".mods" },
    { name: "Metalink", mime: "application/metalink4+xml", extension: ".meta4" },
    { name: "Micro CADAM Helix D&D", mime: "application/vnd.mcd", extension: ".mcd" },
    { name: "Micrografx", mime: "application/vnd.micrografx.flo", extension: ".flo" },
    {
        name: "Micrografx iGrafx Professional",
        mime: "application/vnd.micrografx.igx",
        extension: ".igx",
    },
    { name: "MICROSEC e-Szign¢", mime: "application/vnd.eszigno3+xml", extension: ".es3" },
    { name: "Microsoft Access", mime: "application/x-msaccess", extension: ".mdb" },
    { name: "Microsoft Advanced Systems Format (ASF)", mime: "video/x-ms-asf", extension: ".asf" },
    { name: "Microsoft Application", mime: "application/x-msdownload", extension: ".exe" },
    { name: "Microsoft Artgalry", mime: "application/vnd.ms-artgalry", extension: ".cil" },
    { name: "Microsoft Cabinet File", mime: "application/vnd.ms-cab-compressed", extension: ".cab" },
    { name: "Microsoft Class Server", mime: "application/vnd.ms-ims", extension: ".ims" },
    { name: "Microsoft ClickOnce", mime: "application/x-ms-application", extension: ".application" },
    { name: "Microsoft Clipboard Clip", mime: "application/x-msclip", extension: ".clp" },
    { name: "Microsoft Document Imaging Format", mime: "image/vnd.ms-modi", extension: ".mdi" },
    { name: "Microsoft Embedded OpenType", mime: "application/vnd.ms-fontobject", extension: ".eot" },
    { name: "Microsoft Excel", mime: "application/vnd.ms-excel", extension: ".xls" },
    {
        name: "Microsoft Excel - Add-In File",
        mime: "application/vnd.ms-excel.addin.macroenabled.12",
        extension: ".xlam",
    },
    {
        name: "Microsoft Excel - Binary Workbook",
        mime: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
        extension: ".xlsb",
    },
    {
        name: "Microsoft Excel - Macro-Enabled Template File",
        mime: "application/vnd.ms-excel.template.macroenabled.12",
        extension: ".xltm",
    },
    {
        name: "Microsoft Excel - Macro-Enabled Workbook",
        mime: "application/vnd.ms-excel.sheet.macroenabled.12",
        extension: ".xlsm",
    },
    { name: "Microsoft Html Help File", mime: "application/vnd.ms-htmlhelp", extension: ".chm" },
    { name: "Microsoft Information Card", mime: "application/x-mscardfile", extension: ".crd" },
    { name: "Microsoft Learning Resource Module", mime: "application/vnd.ms-lrm", extension: ".lrm" },
    { name: "Microsoft MediaView", mime: "application/x-msmediaview", extension: ".mvb" },
    { name: "Microsoft Money", mime: "application/x-msmoney", extension: ".mny" },
    {
        name: "Microsoft Office - OOXML - Presentation",
        mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        extension: ".pptx",
    },
    {
        name: "Microsoft Office - OOXML - Presentation (Slide)",
        mime: "application/vnd.openxmlformats-officedocument.presentationml.slide",
        extension: ".sldx",
    },
    {
        name: "Microsoft Office - OOXML - Presentation (Slideshow)",
        mime: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
        extension: ".ppsx",
    },
    {
        name: "Microsoft Office - OOXML - Presentation Template",
        mime: "application/vnd.openxmlformats-officedocument.presentationml.template",
        extension: ".potx",
    },
    {
        name: "Microsoft Office - OOXML - Spreadsheet",
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        extension: ".xlsx",
    },
    {
        name: "Microsoft Office - OOXML - Spreadsheet Template",
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
        extension: ".xltx",
    },
    {
        name: "Microsoft Office - OOXML - Word Document",
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        extension: ".docx",
    },
    {
        name: "Microsoft Office - OOXML - Word Document Template",
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
        extension: ".dotx",
    },
    { name: "Microsoft Office Binder", mime: "application/x-msbinder", extension: ".obd" },
    {
        name: "Microsoft Office System Release Theme",
        mime: "application/vnd.ms-officetheme",
        extension: ".thmx",
    },
    { name: "Microsoft OneNote", mime: "application/onenote", extension: ".onetoc" },
    {
        name: "Microsoft PlayReady Ecosystem",
        mime: "audio/vnd.ms-playready.media.pya",
        extension: ".pya",
    },
    {
        name: "Microsoft PlayReady Ecosystem Video",
        mime: "video/vnd.ms-playready.media.pyv",
        extension: ".pyv",
    },
    { name: "Microsoft PowerPoint", mime: "application/vnd.ms-powerpoint", extension: ".ppt" },
    {
        name: "Microsoft PowerPoint - Add-in file",
        mime: "application/vnd.ms-powerpoint.addin.macroenabled.12",
        extension: ".ppam",
    },
    {
        name: "Microsoft PowerPoint - Macro-Enabled Open XML Slide",
        mime: "application/vnd.ms-powerpoint.slide.macroenabled.12",
        extension: ".sldm",
    },
    {
        name: "Microsoft PowerPoint - Macro-Enabled Presentation File",
        mime: "application/vnd.ms-powerpoint.presentation.macroenabled.12",
        extension: ".pptm",
    },
    {
        name: "Microsoft PowerPoint - Macro-Enabled Slide Show File",
        mime: "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
        extension: ".ppsm",
    },
    {
        name: "Microsoft PowerPoint - Macro-Enabled Template File",
        mime: "application/vnd.ms-powerpoint.template.macroenabled.12",
        extension: ".potm",
    },
    { name: "Microsoft Project", mime: "application/vnd.ms-project", extension: ".mpp" },
    { name: "Microsoft Publisher", mime: "application/x-mspublisher", extension: ".pub" },
    { name: "Microsoft Schedule+", mime: "application/x-msschedule", extension: ".scd" },
    { name: "Microsoft Silverlight", mime: "application/x-silverlight-app", extension: ".xap" },
    {
        name: "Microsoft Trust UI Provider - Certificate Trust Link",
        mime: "application/vnd.ms-pki.stl",
        extension: ".stl",
    },
    {
        name: "Microsoft Trust UI Provider - Security Catalog",
        mime: "application/vnd.ms-pki.seccat",
        extension: ".cat",
    },
    { name: "Microsoft Visio", mime: "application/vnd.visio", extension: ".vsd" },
    { name: "Microsoft Visio 2013", mime: "application/vnd.visio2013", extension: ".vsdx" },
    { name: "Microsoft Windows Media", mime: "video/x-ms-wm", extension: ".wm" },
    { name: "Microsoft Windows Media Audio", mime: "audio/x-ms-wma", extension: ".wma" },
    { name: "Microsoft Windows Media Audio Redirector", mime: "audio/x-ms-wax", extension: ".wax" },
    {
        name: "Microsoft Windows Media Audio/Video Playlist",
        mime: "video/x-ms-wmx",
        extension: ".wmx",
    },
    {
        name: "Microsoft Windows Media Player Download Package",
        mime: "application/x-ms-wmd",
        extension: ".wmd",
    },
    {
        name: "Microsoft Windows Media Player Playlist",
        mime: "application/vnd.ms-wpl",
        extension: ".wpl",
    },
    {
        name: "Microsoft Windows Media Player Skin Package",
        mime: "application/x-ms-wmz",
        extension: ".wmz",
    },
    { name: "Microsoft Windows Media Video", mime: "video/x-ms-wmv", extension: ".wmv" },
    { name: "Microsoft Windows Media Video Playlist", mime: "video/x-ms-wvx", extension: ".wvx" },
    { name: "Microsoft Windows Metafile", mime: "application/x-msmetafile", extension: ".wmf" },
    {
        name: "Microsoft Windows Terminal Services",
        mime: "application/x-msterminal",
        extension: ".trm",
    },
    { name: "Microsoft Word", mime: "application/msword", extension: ".doc" },
    {
        name: "Microsoft Word - Macro-Enabled Document",
        mime: "application/vnd.ms-word.document.macroenabled.12",
        extension: ".docm",
    },
    {
        name: "Microsoft Word - Macro-Enabled Template",
        mime: "application/vnd.ms-word.template.macroenabled.12",
        extension: ".dotm",
    },
    { name: "Microsoft Wordpad", mime: "application/x-mswrite", extension: ".wri" },
    { name: "Microsoft Works", mime: "application/vnd.ms-works", extension: ".wps" },
    { name: "Microsoft XAML Browser Application", mime: "application/x-ms-xbap", extension: ".xbap" },
    {
        name: "Microsoft XML Paper Specification",
        mime: "application/vnd.ms-xpsdocument",
        extension: ".xps",
    },
    { name: "MIDI - Musical Instrument Digital Interface", mime: "audio/midi", extension: ".mid" },
    { name: "MiniPay", mime: "application/vnd.ibm.minipay", extension: ".mpy" },
    { name: "MO:DCA-P", mime: "application/vnd.ibm.modcap", extension: ".afp" },
    {
        name: "Mobile Information Device Profile",
        mime: "application/vnd.jcp.javame.midlet-rms",
        extension: ".rms",
    },
    { name: "MobileTV", mime: "application/vnd.tmobile-livetv", extension: ".tmo" },
    { name: "Mobipocket", mime: "application/x-mobipocket-ebook", extension: ".prc" },
    {
        name: "Mobius Management Systems - Basket file",
        mime: "application/vnd.mobius.mbk",
        extension: ".mbk",
    },
    {
        name: "Mobius Management Systems - Distribution Database",
        mime: "application/vnd.mobius.dis",
        extension: ".dis",
    },
    {
        name: "Mobius Management Systems - Policy Definition Language File",
        mime: "application/vnd.mobius.plc",
        extension: ".plc",
    },
    {
        name: "Mobius Management Systems - Query File",
        mime: "application/vnd.mobius.mqy",
        extension: ".mqy",
    },
    {
        name: "Mobius Management Systems - Script Language",
        mime: "application/vnd.mobius.msl",
        extension: ".msl",
    },
    {
        name: "Mobius Management Systems - Topic Index File",
        mime: "application/vnd.mobius.txf",
        extension: ".txf",
    },
    {
        name: "Mobius Management Systems - UniversalArchive",
        mime: "application/vnd.mobius.daf",
        extension: ".daf",
    },
    { name: "mod_fly / fly.cgi", mime: "text/vnd.fly", extension: ".fly" },
    { name: "Mophun Certificate", mime: "application/vnd.mophun.certificate", extension: ".mpc" },
    { name: "Mophun VM", mime: "application/vnd.mophun.application", extension: ".mpn" },
    { name: "Motion JPEG 2000", mime: "video/mj2", extension: ".mj2" },
    { name: "MPEG Audio", mime: "audio/mpeg", extension: ".mpga" },
    { name: "MPEG Url", mime: "video/vnd.mpegurl", extension: ".mxu" },
    { name: "MPEG Video", mime: "video/mpeg", extension: ".mpeg" },
    { name: "MPEG-21", mime: "application/mp21", extension: ".m21" },
    { name: "MPEG-4 Audio", mime: "audio/mp4", extension: ".mp4a" },
    { name: "MPEG-4 Video", mime: "video/mp4", extension: ".mp4" },
    { name: "MPEG4", mime: "application/mp4", extension: ".mp4" },
    {
        name: "Multimedia Playlist Unicode",
        mime: "application/vnd.apple.mpegurl",
        extension: ".m3u8",
    },
    {
        name: "MUsical Score Interpreted Code Invented for the ASCII designation of Notation",
        mime: "application/vnd.musician",
        extension: ".mus",
    },
    {
        name: "Muvee Automatic Video Editing",
        mime: "application/vnd.muvee.style",
        extension: ".msty",
    },
    { name: "MXML", mime: "application/xv+xml", extension: ".mxml" },
    { name: "N-Gage Game Data", mime: "application/vnd.nokia.n-gage.data", extension: ".ngdat" },
    {
        name: "N-Gage Game Installer",
        mime: "application/vnd.nokia.n-gage.symbian.install",
        extension: ".n-gage",
    },
    {
        name: "Navigation Control file for XML (for ePub)",
        mime: "application/x-dtbncx+xml",
        extension: ".ncx",
    },
    { name: "Network Common Data Form (NetCDF)", mime: "application/x-netcdf", extension: ".nc" },
    { name: "neuroLanguage", mime: "application/vnd.neurolanguage.nlu", extension: ".nlu" },
    { name: "New Moon Liftoff/DNA", mime: "application/vnd.dna", extension: ".dna" },
    { name: "NobleNet Directory", mime: "application/vnd.noblenet-directory", extension: ".nnd" },
    { name: "NobleNet Sealer", mime: "application/vnd.noblenet-sealer", extension: ".nns" },
    { name: "NobleNet Web", mime: "application/vnd.noblenet-web", extension: ".nnw" },
    {
        name: "Nokia Radio Application - Preset",
        mime: "application/vnd.nokia.radio-preset",
        extension: ".rpst",
    },
    {
        name: "Nokia Radio Application - Preset",
        mime: "application/vnd.nokia.radio-presets",
        extension: ".rpss",
    },
    { name: "Notation3", mime: "text/n3", extension: ".n3" },
    {
        name: "Novadigm's RADIA and EDM products",
        mime: "application/vnd.novadigm.edm",
        extension: ".edm",
    },
    {
        name: "Novadigm's RADIA and EDM products",
        mime: "application/vnd.novadigm.edx",
        extension: ".edx",
    },
    {
        name: "Novadigm's RADIA and EDM products",
        mime: "application/vnd.novadigm.ext",
        extension: ".ext",
    },
    { name: "NpGraphIt", mime: "application/vnd.flographit", extension: ".gph" },
    { name: "Nuera ECELP 4800", mime: "audio/vnd.nuera.ecelp4800", extension: ".ecelp4800" },
    { name: "Nuera ECELP 7470", mime: "audio/vnd.nuera.ecelp7470", extension: ".ecelp7470" },
    { name: "Nuera ECELP 9600", mime: "audio/vnd.nuera.ecelp9600", extension: ".ecelp9600" },
    { name: "Office Document Architecture", mime: "application/oda", extension: ".oda" },
    { name: "Ogg", mime: "application/ogg", extension: ".ogx" },
    { name: "Ogg Audio", mime: "audio/ogg", extension: ".oga" },
    { name: "Ogg Video", mime: "video/ogg", extension: ".ogv" },
    { name: "OMA Download Agents", mime: "application/vnd.oma.dd2+xml", extension: ".dd2" },
    {
        name: "Open Document Text Web",
        mime: "application/vnd.oasis.opendocument.text-web",
        extension: ".oth",
    },
    {
        name: "Open eBook Publication Structure",
        mime: "application/oebps-package+xml",
        extension: ".opf",
    },
    { name: "Open Financial Exchange", mime: "application/vnd.intu.qbo", extension: ".qbo" },
    {
        name: "Open Office Extension",
        mime: "application/vnd.openofficeorg.extension",
        extension: ".oxt",
    },
    { name: "Open Score Format", mime: "application/vnd.yamaha.openscoreformat", extension: ".osf" },
    { name: "Open Web Media Project - Audio", mime: "audio/webm", extension: ".weba" },
    { name: "Open Web Media Project - Video", mime: "video/webm", extension: ".webm" },
    {
        name: "OpenDocument Chart",
        mime: "application/vnd.oasis.opendocument.chart",
        extension: ".odc",
    },
    {
        name: "OpenDocument Chart Template",
        mime: "application/vnd.oasis.opendocument.chart-template",
        extension: ".otc",
    },
    {
        name: "OpenDocument Database",
        mime: "application/vnd.oasis.opendocument.database",
        extension: ".odb",
    },
    {
        name: "OpenDocument Formula",
        mime: "application/vnd.oasis.opendocument.formula",
        extension: ".odf",
    },
    {
        name: "OpenDocument Formula Template",
        mime: "application/vnd.oasis.opendocument.formula-template",
        extension: ".odft",
    },
    {
        name: "OpenDocument Graphics",
        mime: "application/vnd.oasis.opendocument.graphics",
        extension: ".odg",
    },
    {
        name: "OpenDocument Graphics Template",
        mime: "application/vnd.oasis.opendocument.graphics-template",
        extension: ".otg",
    },
    {
        name: "OpenDocument Image",
        mime: "application/vnd.oasis.opendocument.image",
        extension: ".odi",
    },
    {
        name: "OpenDocument Image Template",
        mime: "application/vnd.oasis.opendocument.image-template",
        extension: ".oti",
    },
    {
        name: "OpenDocument Presentation",
        mime: "application/vnd.oasis.opendocument.presentation",
        extension: ".odp",
    },
    {
        name: "OpenDocument Presentation Template",
        mime: "application/vnd.oasis.opendocument.presentation-template",
        extension: ".otp",
    },
    {
        name: "OpenDocument Spreadsheet",
        mime: "application/vnd.oasis.opendocument.spreadsheet",
        extension: ".ods",
    },
    {
        name: "OpenDocument Spreadsheet Template",
        mime: "application/vnd.oasis.opendocument.spreadsheet-template",
        extension: ".ots",
    },
    { name: "OpenDocument Text", mime: "application/vnd.oasis.opendocument.text", extension: ".odt" },
    {
        name: "OpenDocument Text Master",
        mime: "application/vnd.oasis.opendocument.text-master",
        extension: ".odm",
    },
    {
        name: "OpenDocument Text Template",
        mime: "application/vnd.oasis.opendocument.text-template",
        extension: ".ott",
    },
    { name: "OpenGL Textures (KTX)", mime: "image/ktx", extension: ".ktx" },
    {
        name: "OpenOffice - Calc (Spreadsheet)",
        mime: "application/vnd.sun.xml.calc",
        extension: ".sxc",
    },
    {
        name: "OpenOffice - Calc Template (Spreadsheet)",
        mime: "application/vnd.sun.xml.calc.template",
        extension: ".stc",
    },
    { name: "OpenOffice - Draw (Graphics)", mime: "application/vnd.sun.xml.draw", extension: ".sxd" },
    {
        name: "OpenOffice - Draw Template (Graphics)",
        mime: "application/vnd.sun.xml.draw.template",
        extension: ".std",
    },
    {
        name: "OpenOffice - Impress (Presentation)",
        mime: "application/vnd.sun.xml.impress",
        extension: ".sxi",
    },
    {
        name: "OpenOffice - Impress Template (Presentation)",
        mime: "application/vnd.sun.xml.impress.template",
        extension: ".sti",
    },
    { name: "OpenOffice - Math (Formula)", mime: "application/vnd.sun.xml.math", extension: ".sxm" },
    {
        name: "OpenOffice - Writer (Text - HTML)",
        mime: "application/vnd.sun.xml.writer",
        extension: ".sxw",
    },
    {
        name: "OpenOffice - Writer (Text - HTML)",
        mime: "application/vnd.sun.xml.writer.global",
        extension: ".sxg",
    },
    {
        name: "OpenOffice - Writer Template (Text - HTML)",
        mime: "application/vnd.sun.xml.writer.template",
        extension: ".stw",
    },
    { name: "OpenType Font File", mime: "application/x-font-otf", extension: ".otf" },
    {
        name: "OSFPVG",
        mime: "application/vnd.yamaha.openscoreformat.osfpvg+xml",
        extension: ".osfpvg",
    },
    { name: "OSGi Deployment Package", mime: "application/vnd.osgi.dp", extension: ".dp" },
    { name: "PalmOS Data", mime: "application/vnd.palm", extension: ".pdb" },
    { name: "Pascal Source File", mime: "text/x-pascal", extension: ".p" },
    { name: "PawaaFILE", mime: "application/vnd.pawaafile", extension: ".paw" },
    {
        name: "PCL 6 Enhanced (Formely PCL XL)",
        mime: "application/vnd.hp-pclxl",
        extension: ".pclxl",
    },
    { name: "Pcsel eFIF File", mime: "application/vnd.picsel", extension: ".efif" },
    { name: "PCX Image", mime: "image/x-pcx", extension: ".pcx" },
    { name: "Photoshop Document", mime: "image/vnd.adobe.photoshop", extension: ".psd" },
    { name: "PICSRules", mime: "application/pics-rules", extension: ".prf" },
    { name: "PICT Image", mime: "image/x-pict", extension: ".pic" },
    { name: "pIRCh", mime: "application/x-chat", extension: ".chat" },
    {
        name: "PKCS #10 - Certification Request Standard",
        mime: "application/pkcs10",
        extension: ".p10",
    },
    {
        name: "PKCS #12 - Personal Information Exchange Syntax Standard",
        mime: "application/x-pkcs12",
        extension: ".p12",
    },
    {
        name: "PKCS #7 - Cryptographic Message Syntax Standard",
        mime: "application/pkcs7-mime",
        extension: ".p7m",
    },
    {
        name: "PKCS #7 - Cryptographic Message Syntax Standard",
        mime: "application/pkcs7-signature",
        extension: ".p7s",
    },
    {
        name: "PKCS #7 - Cryptographic Message Syntax Standard (Certificate Request Response)",
        mime: "application/x-pkcs7-certreqresp",
        extension: ".p7r",
    },
    {
        name: "PKCS #7 - Cryptographic Message Syntax Standard (Certificates)",
        mime: "application/x-pkcs7-certificates",
        extension: ".p7b",
    },
    {
        name: "PKCS #8 - Private-Key Information Syntax Standard",
        mime: "application/pkcs8",
        extension: ".p8",
    },
    { name: "PocketLearn Viewers", mime: "application/vnd.pocketlearn", extension: ".plf" },
    { name: "Portable Anymap Image", mime: "image/x-portable-anymap", extension: ".pnm" },
    { name: "Portable Bitmap Format", mime: "image/x-portable-bitmap", extension: ".pbm" },
    { name: "Portable Compiled Format", mime: "application/x-font-pcf", extension: ".pcf" },
    { name: "Portable Font Resource", mime: "application/font-tdpfr", extension: ".pfr" },
    {
        name: "Portable Game Notation (Chess Games)",
        mime: "application/x-chess-pgn",
        extension: ".pgn",
    },
    { name: "Portable Graymap Format", mime: "image/x-portable-graymap", extension: ".pgm" },
    { name: "Portable Network Graphics (PNG)", mime: "image/png", extension: ".png" },
    {
        name: "Portable Network Graphics (PNG) (Citrix client)",
        mime: "image/x-citrix-png",
        extension: ".png",
    },
    { name: "Portable Network Graphics (PNG) (x-token)", mime: "image/x-png", extension: ".png" },
    { name: "Portable Pixmap Format", mime: "image/x-portable-pixmap", extension: ".ppm" },
    { name: "Portable Symmetric Key Container", mime: "application/pskc+xml", extension: ".pskcxml" },
    { name: "PosML", mime: "application/vnd.ctc-posml", extension: ".pml" },
    { name: "PostScript", mime: "application/postscript", extension: ".ai" },
    { name: "PostScript Fonts", mime: "application/x-font-type1", extension: ".pfa" },
    { name: "PowerBuilder", mime: "application/vnd.powerbuilder6", extension: ".pbd" },
    { name: "Pretty Good Privacy", mime: "application/pgp-encrypted", extension: ".pgp" },
    { name: "Pretty Good Privacy - Signature", mime: "application/pgp-signature", extension: ".pgp" },
    {
        name: "Preview Systems ZipLock/VBox",
        mime: "application/vnd.previewsystems.box",
        extension: ".box",
    },
    { name: "Princeton Video Image", mime: "application/vnd.pvi.ptid1", extension: ".ptid" },
    { name: "Pronunciation Lexicon Specification", mime: "application/pls+xml", extension: ".pls" },
    {
        name: "Proprietary P&G Standard Reporting System",
        mime: "application/vnd.pg.format",
        extension: ".str",
    },
    {
        name: "Proprietary P&G Standard Reporting System",
        mime: "application/vnd.pg.osasli",
        extension: ".ei6",
    },
    { name: "PRS Lines Tag", mime: "text/prs.lines.tag", extension: ".dsc" },
    { name: "PSF Fonts", mime: "application/x-font-linux-psf", extension: ".psf" },
    { name: "PubliShare Objects", mime: "application/vnd.publishare-delta-tree", extension: ".qps" },
    {
        name: "Qualcomm's Plaza Mobile Internet",
        mime: "application/vnd.pmi.widget",
        extension: ".wg",
    },
    { name: "QuarkXpress", mime: "application/vnd.quark.quarkxpress", extension: ".qxd" },
    { name: "QUASS Stream Player", mime: "application/vnd.epson.esf", extension: ".esf" },
    { name: "QUASS Stream Player", mime: "application/vnd.epson.msf", extension: ".msf" },
    { name: "QUASS Stream Player", mime: "application/vnd.epson.ssf", extension: ".ssf" },
    { name: "QuickAnime Player", mime: "application/vnd.epson.quickanime", extension: ".qam" },
    { name: "Quicken", mime: "application/vnd.intu.qfx", extension: ".qfx" },
    // { name: "Quicktime Video", mime: "video/quicktime", extension: ".qt" },
    { name: "RAR Archive", mime: "application/x-rar-compressed", extension: ".rar" },
    { name: "Real Audio Sound", mime: "audio/x-pn-realaudio", extension: ".ram" },
    { name: "Real Audio Sound", mime: "audio/x-pn-realaudio-plugin", extension: ".rmp" },
    { name: "Really Simple Discovery", mime: "application/rsd+xml", extension: ".rsd" },
    { name: "RealMedia", mime: "application/vnd.rn-realmedia", extension: ".rm" },
    { name: "RealVNC", mime: "application/vnd.realvnc.bed", extension: ".bed" },
    { name: "Recordare Applications", mime: "application/vnd.recordare.musicxml", extension: ".mxl" },
    {
        name: "Recordare Applications",
        mime: "application/vnd.recordare.musicxml+xml",
        extension: ".musicxml",
    },
    {
        name: "Relax NG Compact Syntax",
        mime: "application/relax-ng-compact-syntax",
        extension: ".rnc",
    },
    { name: "RemoteDocs R-Viewer", mime: "application/vnd.data-vision.rdz", extension: ".rdz" },
    { name: "Resource Description Framework", mime: "application/rdf+xml", extension: ".rdf" },
    { name: "RetroPlatform Player", mime: "application/vnd.cloanto.rp9", extension: ".rp9" },
    { name: "RhymBox", mime: "application/vnd.jisp", extension: ".jisp" },
    { name: "Rich Text Format", mime: "application/rtf", extension: ".rtf" },
    { name: "Rich Text Format (RTF)", mime: "text/richtext", extension: ".rtx" },
    {
        name: "ROUTE 66 Location Based Services",
        mime: "application/vnd.route66.link66+xml",
        extension: ".link66",
    },
    { name: "RSS - Really Simple Syndication", mime: "application/rss+xml", extension: ".rss, .xml" },
    { name: "S Hexdump Format", mime: "application/shf+xml", extension: ".shf" },
    { name: "SailingTracker", mime: "application/vnd.sailingtracker.track", extension: ".st" },
    { name: "Scalable Vector Graphics (SVG)", mime: "image/svg+xml", extension: ".svg" },
    { name: "ScheduleUs", mime: "application/vnd.sus-calendar", extension: ".sus" },
    {
        name: "Search/Retrieve via URL Response Format",
        mime: "application/sru+xml",
        extension: ".sru",
    },
    {
        name: "Secure Electronic Transaction - Payment",
        mime: "application/set-payment-initiation",
        extension: ".setpay",
    },
    {
        name: "Secure Electronic Transaction - Registration",
        mime: "application/set-registration-initiation",
        extension: ".setreg",
    },
    { name: "Secured eMail", mime: "application/vnd.sema", extension: ".sema" },
    { name: "Secured eMail", mime: "application/vnd.semd", extension: ".semd" },
    { name: "Secured eMail", mime: "application/vnd.semf", extension: ".semf" },
    { name: "SeeMail", mime: "application/vnd.seemail", extension: ".see" },
    { name: "Server Normal Format", mime: "application/x-font-snf", extension: ".snf" },
    {
        name: "Server-Based Certificate Validation Protocol - Validation Policies - Request",
        mime: "application/scvp-vp-request",
        extension: ".spq",
    },
    {
        name: "Server-Based Certificate Validation Protocol - Validation Policies - Response",
        mime: "application/scvp-vp-response",
        extension: ".spp",
    },
    {
        name: "Server-Based Certificate Validation Protocol - Validation Request",
        mime: "application/scvp-cv-request",
        extension: ".scq",
    },
    {
        name: "Server-Based Certificate Validation Protocol - Validation Response",
        mime: "application/scvp-cv-response",
        extension: ".scs",
    },
    { name: "Session Description Protocol", mime: "application/sdp", extension: ".sdp" },
    { name: "Setext", mime: "text/x-setext", extension: ".etx" },
    { name: "SGI Movie", mime: "video/x-sgi-movie", extension: ".movie" },
    { name: "QuickTime Video", mime: "video/quicktime", extension: ".mov" },
    {
        name: "Shana Informed Filler",
        mime: "application/vnd.shana.informed.formdata",
        extension: ".ifm",
    },
    {
        name: "Shana Informed Filler",
        mime: "application/vnd.shana.informed.formtemplate",
        extension: ".itp",
    },
    {
        name: "Shana Informed Filler",
        mime: "application/vnd.shana.informed.interchange",
        extension: ".iif",
    },
    {
        name: "Shana Informed Filler",
        mime: "application/vnd.shana.informed.package",
        extension: ".ipk",
    },
    { name: "Sharing Transaction Fraud Data", mime: "application/thraud+xml", extension: ".tfi" },
    { name: "Shell Archive", mime: "application/x-shar", extension: ".shar" },
    { name: "Silicon Graphics RGB Bitmap", mime: "image/x-rgb", extension: ".rgb" },
    { name: "SimpleAnimeLite Player", mime: "application/vnd.epson.salt", extension: ".slt" },
    { name: "Simply Accounting", mime: "application/vnd.accpac.simply.aso", extension: ".aso" },
    {
        name: "Simply Accounting - Data Import",
        mime: "application/vnd.accpac.simply.imp",
        extension: ".imp",
    },
    { name: "SimTech MindMapper", mime: "application/vnd.simtech-mindmapper", extension: ".twd" },
    {
        name: "Sixth Floor Media - CommonSpace",
        mime: "application/vnd.commonspace",
        extension: ".csp",
    },
    { name: "SMAF Audio", mime: "application/vnd.yamaha.smaf-audio", extension: ".saf" },
    { name: "SMAF File", mime: "application/vnd.smaf", extension: ".mmf" },
    { name: "SMAF Phrase", mime: "application/vnd.yamaha.smaf-phrase", extension: ".spf" },
    { name: "SMART Technologies Apps", mime: "application/vnd.smart.teacher", extension: ".teacher" },
    { name: "SourceView Document", mime: "application/vnd.svd", extension: ".svd" },
    { name: "SPARQL - Query", mime: "application/sparql-query", extension: ".rq" },
    { name: "SPARQL - Results", mime: "application/sparql-results+xml", extension: ".srx" },
    {
        name: "Speech Recognition Grammar Specification",
        mime: "application/srgs",
        extension: ".gram",
    },
    {
        name: "Speech Recognition Grammar Specification - XML",
        mime: "application/srgs+xml",
        extension: ".grxml",
    },
    { name: "Speech Synthesis Markup Language", mime: "application/ssml+xml", extension: ".ssml" },
    { name: "SSEYO Koan Play File", mime: "application/vnd.koan", extension: ".skp" },
    { name: "Standard Generalized Markup Language (SGML)", mime: "text/sgml", extension: ".sgml" },
    { name: "StarOffice - Calc", mime: "application/vnd.stardivision.calc", extension: ".sdc" },
    { name: "StarOffice - Draw", mime: "application/vnd.stardivision.draw", extension: ".sda" },
    { name: "StarOffice - Impress", mime: "application/vnd.stardivision.impress", extension: ".sdd" },
    { name: "StarOffice - Math", mime: "application/vnd.stardivision.math", extension: ".smf" },
    { name: "StarOffice - Writer", mime: "application/vnd.stardivision.writer", extension: ".sdw" },
    {
        name: "StarOffice - Writer (Global)",
        mime: "application/vnd.stardivision.writer-global",
        extension: ".sgl",
    },
    { name: "StepMania", mime: "application/vnd.stepmania.stepchart", extension: ".sm" },
    { name: "Stuffit Archive", mime: "application/x-stuffit", extension: ".sit" },
    { name: "Stuffit Archive", mime: "application/x-stuffitx", extension: ".sitx" },
    { name: "SudokuMagic", mime: "application/vnd.solent.sdkm+xml", extension: ".sdkm" },
    { name: "Sugar Linux Application Bundle", mime: "application/vnd.olpc-sugar", extension: ".xo" },
    { name: "Sun Audio - Au file format", mime: "audio/basic", extension: ".au" },
    { name: "SundaHus WQ", mime: "application/vnd.wqd", extension: ".wqd" },
    { name: "Symbian Install Package", mime: "application/vnd.symbian.install", extension: ".sis" },
    {
        name: "Synchronized Multimedia Integration Language",
        mime: "application/smil+xml",
        extension: ".smi",
    },
    { name: "SyncML", mime: "application/vnd.syncml+xml", extension: ".xsm" },
    {
        name: "SyncML - Device Management",
        mime: "application/vnd.syncml.dm+wbxml",
        extension: ".bdm",
    },
    { name: "SyncML - Device Management", mime: "application/vnd.syncml.dm+xml", extension: ".xdm" },
    { name: "System V Release 4 CPIO Archive", mime: "application/x-sv4cpio", extension: ".sv4cpio" },
    {
        name: "System V Release 4 CPIO Checksum Data",
        mime: "application/x-sv4crc",
        extension: ".sv4crc",
    },
    { name: "Systems Biology Markup Language", mime: "application/sbml+xml", extension: ".sbml" },
    { name: "Tab Seperated Values", mime: "text/tab-separated-values", extension: ".tsv" },
    { name: "Tagged Image File Format", mime: "image/tiff", extension: ".tiff" },
    { name: "Tao Intent", mime: "application/vnd.tao.intent-module-archive", extension: ".tao" },
    { name: "Tar File (Tape Archive)", mime: "application/x-tar", extension: ".tar" },
    { name: "Tcl Script", mime: "application/x-tcl", extension: ".tcl" },
    { name: "TeX", mime: "application/x-tex", extension: ".tex" },
    { name: "TeX Font Metric", mime: "application/x-tex-tfm", extension: ".tfm" },
    { name: "Text Encoding and Interchange", mime: "application/tei+xml", extension: ".tei" },
    { name: "Text File", mime: "text/plain", extension: ".txt" },
    { name: "TIBCO Spotfire", mime: "application/vnd.spotfire.dxp", extension: ".dxp" },
    { name: "TIBCO Spotfire", mime: "application/vnd.spotfire.sfs", extension: ".sfs" },
    { name: "Time Stamped Data Envelope", mime: "application/timestamped-data", extension: ".tsd" },
    { name: "TRI Systems Config", mime: "application/vnd.trid.tpt", extension: ".tpt" },
    { name: "Triscape Map Explorer", mime: "application/vnd.triscape.mxs", extension: ".mxs" },
    { name: "troff", mime: "text/troff", extension: ".t" },
    { name: "True BASIC", mime: "application/vnd.trueapp", extension: ".tra" },
    { name: "TrueType Font", mime: "application/x-font-ttf", extension: ".ttf" },
    { name: "Turtle (Terse RDF Triple Language)", mime: "text/turtle", extension: ".ttl" },
    { name: "UMAJIN", mime: "application/vnd.umajin", extension: ".umj" },
    { name: "Unique Object Markup Language", mime: "application/vnd.uoml+xml", extension: ".uoml" },
    { name: "Unity 3d", mime: "application/vnd.unity", extension: ".unityweb" },
    { name: "Universal Forms Description Language", mime: "application/vnd.ufdl", extension: ".ufd" },
    { name: "URI Resolution Services", mime: "text/uri-list", extension: ".uri" },
    {
        name: "User Interface Quartz - Theme (Symbian)",
        mime: "application/vnd.uiq.theme",
        extension: ".utz",
    },
    {
        name: "Ustar (Uniform Standard Tape Archive)",
        mime: "application/x-ustar",
        extension: ".ustar",
    },
    { name: "UUEncode", mime: "text/x-uuencode", extension: ".uu" },
    { name: "vCalendar", mime: "text/x-vcalendar", extension: ".vcs" },
    { name: "vCard", mime: "text/x-vcard", extension: ".vcf" },
    { name: "Video CD", mime: "application/x-cdlink", extension: ".vcd" },
    { name: "Viewport+", mime: "application/vnd.vsf", extension: ".vsf" },
    { name: "Virtual Reality Modeling Language", mime: "model/vrml", extension: ".wrl" },
    { name: "VirtualCatalog", mime: "application/vnd.vcx", extension: ".vcx" },
    { name: "Virtue MTS", mime: "model/vnd.mts", extension: ".mts" },
    { name: "Virtue VTU", mime: "model/vnd.vtu", extension: ".vtu" },
    { name: "Visionary", mime: "application/vnd.visionary", extension: ".vis" },
    { name: "Vivo", mime: "video/vnd.vivo", extension: ".viv" },
    { name: "Voice Browser Call Control", mime: "application/ccxml+xml,", extension: ".ccxml" },
    { name: "VoiceXML", mime: "application/voicexml+xml", extension: ".vxml" },
    { name: "WAIS Source", mime: "application/x-wais-source", extension: ".src" },
    { name: "WAP Binary XML (WBXML)", mime: "application/vnd.wap.wbxml", extension: ".wbxml" },
    { name: "WAP Bitamp (WBMP)", mime: "image/vnd.wap.wbmp", extension: ".wbmp" },
    { name: "Waveform Audio File Format (WAV)", mime: "audio/x-wav", extension: ".wav" },
    {
        name: "Web Distributed Authoring and Versioning",
        mime: "application/davmount+xml",
        extension: ".davmount",
    },
    { name: "Web Open Font Format", mime: "application/x-font-woff", extension: ".woff" },
    { name: "Web Services Policy", mime: "application/wspolicy+xml", extension: ".wspolicy" },
    { name: "WebP Image", mime: "image/webp", extension: ".webp" },
    { name: "WebTurbo", mime: "application/vnd.webturbo", extension: ".wtb" },
    { name: "Widget Packaging and XML Configuration", mime: "application/widget", extension: ".wgt" },
    { name: "WinHelp", mime: "application/winhlp", extension: ".hlp" },
    { name: "Wireless Markup Language (WML)", mime: "text/vnd.wap.wml", extension: ".wml" },
    {
        name: "Wireless Markup Language Script (WMLScript)",
        mime: "text/vnd.wap.wmlscript",
        extension: ".wmls",
    },
    { name: "WMLScript", mime: "application/vnd.wap.wmlscriptc", extension: ".wmlsc" },
    { name: "Wordperfect", mime: "application/vnd.wordperfect", extension: ".wpd" },
    { name: "Worldtalk", mime: "application/vnd.wt.stf", extension: ".stf" },
    {
        name: "WSDL - Web Services Description Language",
        mime: "application/wsdl+xml",
        extension: ".wsdl",
    },
    { name: "X BitMap", mime: "image/x-xbitmap", extension: ".xbm" },
    { name: "X PixMap", mime: "image/x-xpixmap", extension: ".xpm" },
    { name: "X Window Dump", mime: "image/x-xwindowdump", extension: ".xwd" },
    { name: "X.509 Certificate", mime: "application/x-x509-ca-cert", extension: ".der" },
    { name: "Xfig", mime: "application/x-xfig", extension: ".fig" },
    {
        name: "XHTML - The Extensible HyperText Markup Language",
        mime: "application/xhtml+xml",
        extension: ".xhtml",
    },
    { name: "XML - Extensible Markup Language", mime: "application/xml", extension: ".xml" },
    {
        name: "XML Configuration Access Protocol - XCAP Diff",
        mime: "application/xcap-diff+xml",
        extension: ".xdf",
    },
    {
        name: "XML Encryption Syntax and Processing",
        mime: "application/xenc+xml",
        extension: ".xenc",
    },
    { name: "XML Patch Framework", mime: "application/patch-ops-error+xml", extension: ".xer" },
    { name: "XML Resource Lists", mime: "application/resource-lists+xml", extension: ".rl" },
    { name: "XML Resource Lists", mime: "application/rls-services+xml", extension: ".rs" },
    {
        name: "XML Resource Lists Diff",
        mime: "application/resource-lists-diff+xml",
        extension: ".rld",
    },
    { name: "XML Transformations", mime: "application/xslt+xml", extension: ".xslt" },
    { name: "XML-Binary Optimized Packaging", mime: "application/xop+xml", extension: ".xop" },
    { name: "XPInstall - Mozilla", mime: "application/x-xpinstall", extension: ".xpi" },
    {
        name: "XSPF - XML Shareable Playlist Format",
        mime: "application/xspf+xml",
        extension: ".xspf",
    },
    {
        name: "XUL - XML User Interface Language",
        mime: "application/vnd.mozilla.xul+xml",
        extension: ".xul",
    },
    { name: "XYZ File Format", mime: "chemical/x-xyz", extension: ".xyz" },
    {
        name: "YAML Ain't Markup Language / Yet Another Markup Language",
        mime: "text/yaml",
        extension: ".yaml",
    },
    { name: "YANG Data Modeling Language", mime: "application/yang", extension: ".yang" },
    { name: "YIN (YANG - XML)", mime: "application/yin+xml", extension: ".yin" },
    { name: "Z.U.L. Geometry", mime: "application/vnd.zul", extension: ".zir" },
    { name: "Zip Archive", mime: "application/zip", extension: ".zip" },
    {
        name: "ZVUE Media Manager",
        mime: "application/vnd.handheld-entertainment+xml",
        extension: ".zmm",
    },
    { name: "Zzazz Deck", mime: "application/vnd.zzazz.deck+xml", extension: ".zaz" },
];
